
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/assignment-edit/jst/EditHeaderView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  <h1 class=\"screenreader-only\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h1>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  \n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.instui_nav), {hash:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    <h1 class=\"screenreader-only\">";
  if (helper = helpers.renderHeaderTitle) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.renderHeaderTitle); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h1>\n  ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <h1 class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_header_view")
  },data:data},helper ? helper.call(depth0, "new_assignment_2a984756", "New Assignment", options) : helperMissing.call(depth0, "t", "new_assignment_2a984756", "New Assignment", options)))
    + "</h1>\n  ";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <div class=\"header-bar-left\">\n          <h1 class='assignment-edit-header-title'>";
  if (helper = helpers.renderHeaderTitle) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.renderHeaderTitle); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h1>\n          <div class=\"published-assignment-container\" style=\"margin-top:0.75rem\"></div>\n      </div>\n    ";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.program(13, program13, data),fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <span id='assignment-draft-state' class='published-status published'>\n              <i class=\"icon-publish icon-Solid\"></i>\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_header_view")
  },data:data},helper ? helper.call(depth0, "published_4bb5209e", "Published", options) : helperMissing.call(depth0, "t", "published_4bb5209e", "Published", options)))
    + "\n            </span>\n          ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <span id='assignment-draft-state' class='published-status unpublished'>\n              <i class=\"icon-unpublished\"></i>\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_header_view")
  },data:data},helper ? helper.call(depth0, "not_published_73f7079", "Not Published", options) : helperMissing.call(depth0, "t", "not_published_73f7079", "Not Published", options)))
    + "\n            </span>\n          ";
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <li class=\"speed-grader-link-container\">\n                <a class=\"icon-speed-grader\" href=\"/courses/";
  if (helper = helpers.courseId) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.courseId); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "/gradebook/speed_grader?assignment_id=";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" target=\"_blank\" rel=\"noopener\">\n                  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_header_view")
  },data:data},helper ? helper.call(depth0, "speedgrader_de0affa6", "SpeedGrader", options) : helperMissing.call(depth0, "t", "speedgrader_de0affa6", "SpeedGrader", options)))
    + "\n                </a>\n              </li>\n            ";
  return buffer;
  }

function program17(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <li class=\"assignment-delete-container\">\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canDelete), {hash:{},inverse:self.program(20, program20, data),fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  <i class=\"icon-trash\"></i>\n                  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_header_view")
  },data:data},helper ? helper.call(depth0, "delete_a6efa79d", "Delete", options) : helperMissing.call(depth0, "t", "delete_a6efa79d", "Delete", options)))
    + "\n                </a>\n              </li>\n            ";
  return buffer;
  }
function program18(depth0,data) {
  
  
  return "\n                <a href=\"#\" class=\"delete_assignment_link\">\n              ";
  }

function program20(depth0,data) {
  
  
  return "\n                <a href=\"#\" class=\"delete_assignment_link disabled\" aria-disabled=true>\n              ";
  }

function program22(depth0,data) {
  
  
  return "\n    <div class='edit-assignment-header-cr'>\n        <div id=\"conditional-release-tabs-mount\"></div>\n        <form id=\"edit_assignment_form\" novalidate></form>\n    </div>\n";
  }

function program24(depth0,data) {
  
  
  return "\n    <form id=\"edit_assignment_form\" novalidate></form>\n";
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.name), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n<div class=\"header-bar assignment-edit-header\" style=\"align-items: flex-start;\">\n    \n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.instui_nav), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <div class=\"header-bar-right assignment-edit-header-right\">\n      <div class=\"header-group-left assignment-edit-header-group-left\">\n        \n        ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.instui_nav), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n      <div class=\"header-group-right\">\n        <div class=\"admin-links\">\n          <button class=\"al-trigger btn\">\n            <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.edit_header_view")
  },data:data},helper ? helper.call(depth0, "manage_assignment_31a132fb", "Manage Assignment", options) : helperMissing.call(depth0, "t", "manage_assignment_31a132fb", "Manage Assignment", options)))
    + "</span>\n            <i class=\"icon-more\" aria-hidden=\"true\"></i>\n          </button>\n          <ul class=\"al-options\">\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showSpeedGraderLink), {hash:{},inverse:self.noop,fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.is_locked), {hash:{},inverse:self.noop,fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </ul>\n        </div>\n      </div>\n    </div>\n</div>\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.CONDITIONAL_RELEASE_SERVICE_ENABLED), {hash:{},inverse:self.program(24, program24, data),fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  